import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { UserService } from '@shared/service/user.service';
import { UserStore } from '@shared/store/user.store';

@Injectable()
export class GroupInterceptor implements HttpInterceptor {
  private readonly _userService = inject(UserService);
  private readonly _storeUser = inject(UserStore);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('auth/signin')) {
      return next.handle(request);
    }

    const user = this._storeUser.user();

    if (!user) {
      return next.handle(request);
    }

    if (!user.currentGroup) {
      this._userService.logout();
      return throwError(() => new Error('Authentication error'));
    }

    return next.handle(request);
  }
}
